import { Component, HostListener, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-ad-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-ad-overlay.component.html',
  styleUrls: ['./product-ad-overlay.component.scss'],
})
export class ProductAdOverlayComponent {
  readonly imageUrl = signal('');
  readonly alt = signal('Propaganda do produto');
  closed = output<void>();

  close(): void {
    this.closed.emit();
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    this.close();
  }
}
